export const state = () => ({
  configBlock: {},

	isOpen: false,
  isLoadConfig: false
});

export const actions = {
  getCongif: async function (params) {
    if (params.state?.isLoadConfig) {
      return
    }

    const pageId = params?.rootState?.appState?.vars?.['Служебная страницы квиза'];
    const response = await this.$api.agent.transport.get(`/cms/page/${pageId}`).then((res) => {
      return res.data
    }).catch(() => {
      return {}
    });
    const quizBlock = (response?.placeholders?.content || []).find((t) => t.block_name === "QuizBlock");
    params.commit("setConfig", quizBlock);
  },
}

export const mutations = {
	open: function (state) {
		state.isOpen = true;
	},
	close: function (state) {
		state.isOpen = false;
	},

  setConfig: function (state, config) {
    state.configBlock = config;
    state.isLoadConfig = true;
  },
};
